export default __webpack_public_path__ + "static/media/afei.b97e7e50.svg";